module.exports = __webpack_public_path__ + "static/logo-presidenza-consiglio-cap-rischio-f836dd3acc8f1c5437aebf166fdd4b79.png";